import { useTranslation } from '@mint-lib/i18n';
import { useProfile } from '@mint-lib/profile-helpers';
import { Tabs, TabsList, TabsTrigger } from '@mint-lib/tw-components';
import { useNavigate } from '@mint/routing';

import useTab from '../../hooks/useTab/useTab.js';

const UserManagementTabs = () => {
  const { t } = useTranslation('@myn/permissions');

  const { profileService } = useProfile();

  const navigate = useNavigate();

  const activeRoute = useTab();

  const isAgencyCompany = profileService.isAgencyCompany();

  return (
    <Tabs value={activeRoute ?? 'user'} orientation="horizontal">
      <TabsList>
        <TabsTrigger
          value="user"
          onClick={() => {
            navigate({
              to: isAgencyCompany
                ? '/agency-hub/users-management/user'
                : '/company-profile/users-management/user',
            });
          }}
          aria-label="switch user tab"
        >
          {t('Users')}
        </TabsTrigger>
        <TabsTrigger
          value="role"
          onClick={() => {
            navigate({
              to: isAgencyCompany
                ? '/agency-hub/users-management/role'
                : '/company-profile/users-management/role',
            });
          }}
          aria-label="switch role tab"
        >
          {t('Roles')}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default UserManagementTabs;
